import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

const Configuration = () => {
    const [categories, setCategories] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [categoryGender, setCategoryGender] = useState('Men');
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/sous-categories/`);
            setCategories(response.data);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await axios.put(`${BASE_URL}/api/sous-categories/${editId}/`, {
                    name: categoryName,
                    gender: categoryGender
                });
                setIsEditing(false);
                setEditId(null);
            } else {
                await axios.post(`${BASE_URL}/api/sous-categories/`, {
                    name: categoryName,
                    gender: categoryGender
                });
            }
            setCategoryName('');
            setCategoryGender('Men');
            fetchCategories();
        } catch (error) {
            console.error("Error saving category:", error);
        }
    };

    const handleEdit = (category) => {
        setCategoryName(category.name);
        setCategoryGender(category.gender);
        setIsEditing(true);
        setEditId(category.id);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${BASE_URL}/api/sous-categories/${id}/`);
            fetchCategories();
        } catch (error) {
            console.error("Error deleting category:", error);
        }
    };

    return (
        <div className="container mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">Sous Category Configuration</h2>
            <form onSubmit={handleSubmit} className="mb-6 p-4 border rounded bg-gray-50">
                <div className="flex flex-col md:flex-row gap-4 items-end">
                    <div className="w-full md:w-1/3">
                        <label className="block text-gray-700 text-sm font-bold mb-2">Category Name</label>
                        <input
                            type="text"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            className="w-full px-3 py-2 border rounded"
                            required
                        />
                    </div>
                    <div className="w-full md:w-1/3">
                        <label className="block text-gray-700 text-sm font-bold mb-2">Collection (Gender)</label>
                        <select
                            value={categoryGender}
                            onChange={(e) => setCategoryGender(e.target.value)}
                            className="w-full px-3 py-2 border rounded"
                        >
                            <option value="Men">Men</option>
                            <option value="Women">Women</option>
                            <option value="Accessoire">Accessoires</option>
                        </select>
                    </div>
                    <div className="w-full md:w-1/3">
                        <button type="submit" className="w-full bg-blue-500 text-white px-4 py-2 rounded">
                            {isEditing ? 'Update Category' : 'Add Category'}
                        </button>
                    </div>
                </div>
                {isEditing && (
                    <button 
                        type="button" 
                        onClick={() => {
                            setIsEditing(false);
                            setEditId(null);
                            setCategoryName('');
                            setCategoryGender('Men');
                        }}
                        className="mt-4 bg-gray-500 text-white px-4 py-2 rounded"
                    >
                        Cancel Edit
                    </button>
                )}
            </form>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {['Men', 'Women', 'Accessoire'].map(gender => (
                    <div key={gender} className="border p-4 rounded shadow bg-white">
                        <h3 className="text-lg font-bold border-b pb-2 mb-4">{gender}</h3>
                        <ul className="space-y-2">
                            {categories.filter(c => c.gender === gender).map(category => (
                                <li key={category.id} className="flex justify-between items-center bg-gray-50 p-2 rounded">
                                    <span>{category.name}</span>
                                    <div className="space-x-2">
                                        <button onClick={() => handleEdit(category)} className="text-blue-500 text-sm">Edit</button>
                                        <button onClick={() => handleDelete(category.id)} className="text-red-500 text-sm">Delete</button>
                                    </div>
                                </li>
                            ))}
                            {categories.filter(c => c.gender === gender).length === 0 && (
                                <li className="text-gray-400 italic text-sm">No categories added yet.</li>
                            )}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Configuration;
